import { apiClient } from '../client'
import {
    CurrentAgent,
    ForgotPasswordPayload,
    ImpersonatePayload,
    LoginPayload,
    LoginResponse,
    RegisterPayload,
    ResetPasswordPayload,
    SaveAgentLanguageResponse,
} from './types'
import { getRefreshToken } from './tokenStorage'

export const login = async (payload: LoginPayload): Promise<LoginResponse> => {
    const response = await apiClient('login_check', {
        method: 'POST',
        data: payload,
    })
    return response.data
}

export const register = async (payload: RegisterPayload): Promise<void> => {
    await apiClient('v1/core/signup', {
        method: 'POST',
        data: payload,
    })
}

export const forgotPassword = async (payload: ForgotPasswordPayload): Promise<void> => {
    await apiClient('v1/core/authentication/password-recovery', {
        method: 'POST',
        data: payload,
    })
}

export const resetPassword = async (payload: ResetPasswordPayload): Promise<void> => {
    await apiClient('v1/core/authentication/password-recovery', {
        method: 'PATCH',
        data: payload,
    })
}

export const invalidateToken = async (): Promise<void> => {
    await apiClient('token/invalidate', {
        method: 'POST',
        data: { refresh_token: getRefreshToken() },
    })
}

export const impersonate = async (payload: ImpersonatePayload): Promise<LoginResponse> => {
    const response = await apiClient('v1/core/backoffice/impersonation/exchange', {
        method: 'POST',
        data: payload,
    })
    return response.data
}

export const fetchCurrentAgent = async (): Promise<CurrentAgent> => {
    const response = await apiClient('v1/core/authentication/agent', {
        method: 'GET',
    })
    return {
        ...response.data,
        userSettings: response.data.userSettings ? JSON.parse(response.data.userSettings) : {},
    }
}

export const saveAgentLanguage = async (locale: string): Promise<SaveAgentLanguageResponse> => {
    const response = await apiClient(`v1/core/authentication/agent-language/${locale}`, {
        method: 'PUT',
    })
    return response.data
}

